import { useState } from "react";
import { api } from "../../lib/api";

export default function AdmissionEligibilityChecker() {
  const [form, setForm] = useState({ programme_name: "", programme_type: "ND", utme_score: "", subjects: "" });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setResult(null);
    try {
      const data = await api("/api/admission/check", {
        method: "POST",
        body: JSON.stringify({
          programme_name: form.programme_name,
          programme_type: form.programme_type,
          utme_score: Number(form.utme_score),
          subjects: form.subjects.split(",").map((item) => item.trim()).filter(Boolean),
        }),
      });
      setResult(data);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <main className="bg-slate-50 px-4 py-16">
      <section className="mx-auto max-w-4xl rounded-3xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Admission Support</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Eligibility Checker</h1>
        <p className="mt-3 text-slate-600">Check whether your subjects and UTME score match the saved admission rules.</p>

        <form onSubmit={submit} className="mt-8 grid gap-4 md:grid-cols-2">
          <input className="rounded-xl border p-3" placeholder="Programme e.g. Computer Science" value={form.programme_name} onChange={(e) => setForm({ ...form, programme_name: e.target.value })} required />
          <select className="rounded-xl border p-3" value={form.programme_type} onChange={(e) => setForm({ ...form, programme_type: e.target.value })}>
            <option value="ND">ND</option>
            <option value="HND">HND</option>
          </select>
          <input className="rounded-xl border p-3" placeholder="UTME score" type="number" value={form.utme_score} onChange={(e) => setForm({ ...form, utme_score: e.target.value })} />
          <input className="rounded-xl border p-3" placeholder="Subjects separated by comma" value={form.subjects} onChange={(e) => setForm({ ...form, subjects: e.target.value })} />
          <button className="rounded-xl bg-emerald-700 px-5 py-3 font-bold text-white md:col-span-2">Check Eligibility</button>
        </form>

        {error && <div className="mt-6 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
        {result && (
          <div className={`mt-6 rounded-2xl p-5 ${result.eligible ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`}>
            <h2 className="text-xl font-bold">{result.status?.replaceAll("_", " ").toUpperCase()}</h2>
            <p className="mt-2">{result.message}</p>
            {result.missing_subjects?.length > 0 && <p className="mt-2 font-semibold">Missing subjects: {result.missing_subjects.join(", ")}</p>}
          </div>
        )}
      </section>
    </main>
  );
}
